import React from "react";
import type {DeserializedGridCellParams} from "../MuiXColumnDefinitions.ts";
import {useStores} from "../../../stores";
import {categoryToLabels} from "../../../services/classes/Category.ts";
import {CategorizationViewOnlyComponent} from "../../categorization/CategorizationViewOnlyComponent.tsx";

export const CategoryReadonlyCell: React.FC<DeserializedGridCellParams> = ({row}) => {
    const {bagStore, p} = useStores();
    if (!row || !row.cat) return <></>;
    const taxonomySize = bagStore.taxonomy_size;
    const labels = categoryToLabels(row.cat, taxonomySize, !!p.p.allowIncompleteTaxonomy, !!p.p.hideRepeatingLabels);
    return <CategorizationViewOnlyComponent category={labels}/>
}
